import env from "../../env";
import React from "react";
import { connect } from "react-redux";
import {
  MDBDropdown,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBDropdownItem,
  MDBBtn,
} from "mdb-react-ui-kit";
import AsyncSelect from "react-select/async";
import { set_visibility_modal } from "../../redux/actions";

/**
 * Toggle visibility modal globally
 * updateEmission function passed
 * emissionData passed
 * Update in modal, fire updateEmission in modal
 */

const darkTheme = {
  primary25: "#1266f1",
  primary50: "#1E88E5",
  primary75: "#42A5F5",
  primary: "#BBDEFB",
  dangerLight: "#f93154",
  danger: "#E57373",
  neutral90: "#fff",
  neutral80: "#f9f9f9",
  neutral70: "#f5f5f5",
  neutral60: "#eeeeee",
  neutral50: "#e0e0e0",
  neutral40: "#bdbdbd",
  neutral30: "#9e9e9e",
  neutral20: "#757575",
  neutral10: "#616161",
  neutral5: "#4f4f4f",
  neutral0: "#262626",
};

const Visibility = ({
  visibility,
  setVisibility,
  userInfo,
  setViewers,
  loadOptions,
  main,
  emission,
  updateEmission,
  set_visibility_modal,
}) => {
  return (
    <div
      className={`d-flex skip-ripple no-route ${
        main ? "justify-content-end" : ""
      } align-items-center ${visibility === "Custom" ? "min-w-50" : ""}`}
    >
      {emission ? (
        <MDBBtn
          className="skip-ripple no-route p-0 cursor-pointer bg-transparent"
          color="link"
          rippleColor="primary"
          onClick={() =>
            set_visibility_modal({
              shown: true,
              emission,
              updateEmission,
            })
          }
        >
          <i className="fas fa-eye me-2 skip-ripple no-route" />
          {emission.visibility?.flavor ? emission.visibility.flavor : "Public"}
        </MDBBtn>
      ) : (
        <>
          <MDBDropdown group className="shadow-0 skip-ripple no-route">
            <MDBDropdownToggle
              className="skip-ripple no-route"
              rippleColor="primary"
              color="link"
            >
              <i className="fas fa-eye me-2 skip-ripple no-route" />
              {visibility}
            </MDBDropdownToggle>
            <MDBDropdownMenu className="skip-ripple no-route">
              <MDBDropdownItem
                onClick={() => setVisibility("Public")}
                className="cursor-pointer skip-ripple no-route"
                link
                childTag="div"
              >
                Public
              </MDBDropdownItem>
              {userInfo._id ? (
                <>
                  <MDBDropdownItem
                    className="cursor-pointer skip-ripple no-route"
                    link
                    childTag="div"
                    onClick={() => setVisibility("Followers")}
                  >
                    {env.FOLLOW_PLURAL}
                  </MDBDropdownItem>
                  <MDBDropdownItem
                    className="cursor-pointer skip-ripple no-route"
                    link
                    childTag="div"
                    onClick={() => setVisibility("People I Follow")}
                  >
                    People I {env.FOLLOW_VERB}
                  </MDBDropdownItem>
                  <MDBDropdownItem
                    onClick={() => setVisibility("Only Me")}
                    className="cursor-pointer skip-ripple no-route"
                    link
                    childTag="div"
                  >
                    Only Me
                  </MDBDropdownItem>
                </>
              ) : (
                <></>
              )}
              <MDBDropdownItem
                onClick={() => setVisibility("Custom")}
                className="cursor-pointer skip-ripple no-route"
                link
                childTag="div"
              >
                Custom
              </MDBDropdownItem>
            </MDBDropdownMenu>
          </MDBDropdown>
          {visibility === "Custom" && (
            <AsyncSelect
              cacheOptions
              onChange={setViewers}
              loadOptions={loadOptions}
              defaultOptions
              placeholder="Allowed Users"
              isMulti
              theme={(theme) => {
                if (userInfo.userSettings.theme === "default") {
                  return theme;
                } else
                  return {
                    ...theme,
                    colors: {
                      ...theme.colors,
                      ...darkTheme,
                    },
                  };
              }}
              className="ms-2 min-w-50 skip-ripple no-route"
            />
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, { set_visibility_modal })(Visibility);
